export default __webpack_public_path__ + "static/media/warning.0cedee3c.svg";